export const BETWEEN = 'between';
export const NOT_BETWEEN = 'notBetween';
export const CONTAIN = 'contain';
export const NOT_CONTAIN = 'notContain';
export const LIKE = 'like';
export const NOT_LIKE = 'notLike';
export const IGNORE_CASE_LIKE = 'ignoreCaseLike';
export const IGNORE_CASE_EQUAL = 'ignoreCaseEqual';
export const IGNORE_CASE_NOT_LIKE = 'ignoreCaseNotLike';
export const START_WITH = 'startWith';
export const END_WITH = 'endWith';
export const EQUAL = 'equal';
export const NOT_EQUAL = 'notEqual';
export const IN = 'in';
export const NOT_IN = 'notIn';
export const LESS_THAN = 'lessThan';
export const LESS_THAN_OR_EQUAL = 'lessThanOrEqual';
export const GREATER_THAN = 'greaterThan';
export const GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual';
export const IS_NULL = 'isNull';
export const IS_NOT_NULL = 'isNotNull';
export const JSON_EXTRACT_EQUAL = 'jsonExtractEqual';
export const JSON_EXTRACT_LIKE = 'jsonExtractLike';
